<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="name" label="节点名称" name="name">
      <a-input v-model:value="formState.name" />
    </a-form-item>
    <a-form-item
      ref="departIds"
      label="关联部门"
      name="departIds"
      :required="!formState.companyCheck"
    >
      <a-tree-select
        v-model:value="formState.departIds"
        :disabled="formState.companyCheck"
        multiple
        show-search
        :placeholder="formState.companyCheck ? '被访企业审核' : '请选择部门'"
        allow-clear
        tree-default-expand-all
        :tree-data="props.treeData"
        tree-node-filter-prop="label"
        :fieldNames="{ label: 'name', value: 'depart_id' }"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        @change="handleDepartChange"
        :maxTagCount="2"
      />
    </a-form-item>
    <a-form-item label="是否会签" ref="countersign" name="countersign">
      <a-radio-group
        v-model:value="formState.countersign"
        :disabled="formState.companyCheck"
      >
        <a-radio :value="0">否</a-radio>
        <a-radio :value="1">是</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="被访企业审核" ref="companyCheck" name="companyCheck">
      <a-radio-group
        v-model:value="formState.companyCheck"
        @change="companyCheckChange"
      >
        <a-radio :value="0">否</a-radio>
        <a-radio :value="1">是</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item
      label="超时自动审核"
      ref="overtimeAutoCheck"
      name="overtimeAutoCheck"
    >
      <a-radio-group v-model:value="formState.overtimeAutoCheck">
        <a-radio :value="0">否</a-radio>
        <a-radio :value="1">是</a-radio>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="角色">
      <a-select
        v-model:value="formState.roleId"
        :options="rolesList"
        placeholder="点击绑定角色"
      ></a-select>
    </a-form-item>

    <a-form-item ref="remark" label="备注" remark="remark">
      <a-input v-model:value="formState.remark" />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 8 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import { createProcNode, updateProcNode } from '@/api/process'

  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    treeData: Array,
    rolesList: Array,
  })

  //表单填写
  const formRef = ref()
  const defaultFormState = props.isEdit
    ? {
        ...props.editData,
        processNodeId: props.editData.process_node_id,
        overtimeAutoCheck: props.editData.overtime_auto_check,
        companyCheck: props.editData.company_check,
        departIds:
          props.editData?.departList &&
          props.editData?.departList.map((item) => item.depart_id),
        roleId: props.editData?.role?.role_id,
      }
    : {
        name: '',
        countersign: '',
        remark: '',
        departIds: [],
        roleId: ''
      }
  const formState = reactive(defaultFormState)

  const rules = computed(() => ({
    name: [
      {
        required: true,
        message: '请输入节点名称',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    countersign: [
      {
        required: true,
        message: '请选择是否会签',
        trigger: 'change',
      },
    ],
    companyCheck: [
      {
        required: true,
        message: '请选择被访企业审核',
        trigger: 'change',
      },
    ],
    overtimeAutoCheck: [
      {
        required: true,
        message: '请选择是否开启超时自动审核',
        trigger: 'change',
      },
    ],
    departIds: [
      {
        required: !formState.companyCheck,
        message: '请选择关联部门',
        trigger: 'blur',
      },
    ],
    roleId: [
      {
        required: true,
        message: '请选择关联角色',
        trigger: 'blur',
      },
    ],
  }))

  function companyCheckChange(e) {
    if (e.target.value === 1) {
      formState.departIds = []
      formState.countersign = 0
    }
  }
  
  function handleDepartChange(selectedIds) {
    formState.departIds = selectedIds || []
  }

  //表单提交
  const emit = defineEmits(['submit'])
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建流程错误：', error)
      })
  }
  async function handelCreate(data) {
    const ajaxFn = props.isEdit ? updateProcNode : createProcNode
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn({ ...data, departIds: data.departIds.toString() })
    if (res.success) {
      message.success(messageText + '流程成功！')
      emit('submit')
    } else {
      message.warn(messageText + '流程错误：', res.message)
    }
  }

  function resetForm() {
    formRef.value.resetFields()
  }
</script>
